import React from 'react';
import { styled } from 'linaria/react';
import { useYotpoWidget } from './Yotpo';
import { theme } from '../Theme';

const ProductRatingsSmallWrapper = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  ${theme.below.lg} {
    justify-content: flex-start;
  }

  .yotpo-stars {
    margin-right: 6px;
  }
`;

export const ProductRatingsSmall = ({ product }) => {
  const loaded = useYotpoWidget();

  return (
    <>
      <div className="yotpo-reviews" />
      {loaded ? (
        <ProductRatingsSmallWrapper>
          <div className="yotpo bottomLine" data-product-id={product.id}></div>
        </ProductRatingsSmallWrapper>
      ) : (
        ''
      )}
    </>
  );
};

export default ProductRatingsSmall;
